import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Table, TableBody, TableCell, TableContainer, Checkbox,
    TableHead, TableRow, Paper, TablePagination, TableFooter, TextField, Autocomplete } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import SCMreadonlyrow from './SCMreadonlyrow';
import SCMeditablerow from './SCMeditablerow';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import styled from 'styled-components';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useForm } from "react-hook-form";
import axios from "axios";
import { useAddAssetInCatMutation, useEditAssetOfCatMutation } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`

const SpecInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const LabelInputWrapper = styled.div`
    /* margin-bottom:25px; */
    min-height: 40px;
    margin-right:20px;
`
const IconWrapper = styled.div`
display: flex;
align-items:center;
justify-content: space-between;
width:100%;
`

const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
margin-left: 25px;
width:120px;
font-size: 0.9rem;
`

const SubWrapper = styled.div`
display: flex;
align-items:center;
  
`

const tableFontSize = 18;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B)=> {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}


const SubCategMaster = ({assetMasterData, setAssetMasterData, categProp, onClickBackArrow,setSentData, deleteAssetMaster, tarray, assetmasters, Button2Div, ExcelDownload}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [addSpecIndex, setAddSpecIndex] = useState(1);
  const [onChangeData, setOnChangeData] = useState({});
  const [editCategory, setEditCategory] = useState(null);
  const [rows, setRows] = useState(tarray(Object.values(assetmasters?.entities)));
  const [downloadData, setDownloadData] = useState({});
  const [searchData, setSearchData] = useState({
    Category:[],
    Name:[],
    Specifications:[],
    values:[]
  });
  const [editData, setEditData] = useState({
    catIndex:null,
    assetIndex:null,
    specIndex:null,
    keyValueObject:{}
  })  
   
  const [addAssetInCat,{
    isLoading:addAssetInCatisLoading,
    isSuccess: addAssetInCatisSuccess,
    isError: addAssetInCatisError,
    error: addAssetInCatError
   }] = useAddAssetInCatMutation();

  const [editAssetOfCat,{
    isLoading:editAssetOfCatisLoading,
    isSuccess: editAssetOfCatisSuccess,
    isError: editAssetOfCatisError,
    error: editAssetOfCatError
  }] = useEditAssetOfCatMutation();

 
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    };


  const onClickaddicon = () =>{
    setAddSpecIndex(addSpecIndex+1)
    }

  const onClickremoveicon = () =>{
    if(addSpecIndex > 1){
        setAddSpecIndex(addSpecIndex-1)
        }
    }

  //Find the index of Category
  const catIndex = assetMasterData.findIndex(p => p.Category === categProp);
  const onChangeAssetData = (event) =>{
    let tempOnChangeData = {...onChangeData};
    if(event.target.name === 'specEdit'){
        let tempEditData = structuredClone(editData);
        const tempKey = Object.keys(tempEditData.keyValueObject)[0];
        tempEditData.keyValueObject[event.target.value.trim()] = tempEditData.keyValueObject[Object.keys(tempEditData.keyValueObject)[0]]
        delete tempEditData.keyValueObject[tempKey];
        setEditData(tempEditData);
        return;
    }
    if(event.target.name === 'valueEdit'){
        let tempEditData = structuredClone(editData);
        tempEditData.keyValueObject[Object.keys(tempEditData.keyValueObject)[0]] = event.target.value.trim();
        setEditData(tempEditData);
        return;
    }
    tempOnChangeData = {...tempOnChangeData, [event.target.name]:event.target.value};
    setOnChangeData(tempOnChangeData);   
    }

  const onFormSubmit = async (e) =>{
    e.preventDefault();
    //Find the index of Asset and value of ID corresponding to the Category
    const id = assetMasterData[catIndex]._id;
    const assetIndex = assetMasterData[catIndex].Asset.findIndex(a => a.Name === onChangeData.AssetName);
    //Evaluate the array of all the Specifications in the original data
    const specsOrigArray = assetIndex !== -1? assetMasterData[catIndex].Asset[assetIndex].Specifications.map(
      (item,index)=>Object.keys(item)).flat(2):[]
    //Find the array of Specifications in the data entered in the form.
    let specs =[];
    for(let i=0; i<addSpecIndex; i++){
      specs.push(onChangeData[`spec${i}`])
    }
    //Check if there is any common(Duplicate value) spec value in the entered data as compared
     //to the original data
    const specDupl = specsOrigArray.some(element => {
      return specs.includes(element);
    });
    //Initialize two empty Arrays, one for new specs and one for updating specs.
    let specArray =[]
    let specEditArray=[]
    for(let i=0; i<addSpecIndex; i++){      
      if( (!onChangeData[`spec${i}`]) || (!onChangeData[`value${i}`])){
        alert("Kindly enter all the values before submitting.");
        return;
      }else if(assetIndex === -1){
        let specObject = {[onChangeData[`spec${i}`]]:(onChangeData[`value${i}`]).split(",").map(val => val.trim())}
        specArray.push(specObject)
      }else if(specDupl){
        alert("The entered Specification value already exists. Please enter only new value. For editing values of existing Specification Kindly edit in table ")
        return;
      }else{
        let specEditObject = {[onChangeData[`spec${i}`]]:(onChangeData[`value${i}`]).split(",").map(val => val.trim())};
        specEditArray.push(specEditObject);
      }
    }
    const body ={"Name":onChangeData.AssetName,"Specifications":specArray, "id":id}
    if(assetIndex === -1){
      const res = await addAssetInCat(body)
      alert(`New Asset ${onChangeData.AssetName} added to Category ${categProp}`)
    }else{
      //Sending the body having modified spec document along with index. Modify later using filter of database.
      const oldSpecArray = assetMasterData [catIndex].Asset[assetIndex].Specifications;
      const finalSpecArray =oldSpecArray.concat(specEditArray);
      const body ={"Name":onChangeData.AssetName,"Specifications":finalSpecArray,"Index":assetIndex,"id":id};
      const res = await editAssetOfCat(body);
      alert(`New Specifications added to Asset ${onChangeData.AssetName} in Category ${categProp} edited successfully.`)
    }
    setOnChangeData({});
    setAddSpecIndex(1)
  }


  const onClickEdit = (e,k,row) =>{
    setEditCategory(k+1)
    const catEditIndex = assetMasterData.findIndex(a=> a.Category === row.Category)
    const assetIndex = assetMasterData[catEditIndex].Asset.findIndex(a => a.Name === row.Name);
    if(assetIndex === -1){
      alert(`Please add Asset before editing`)
      setEditCategory(null);
      return;
    }
    const specIndex = assetMasterData[catEditIndex].Asset[assetIndex].Specifications.findIndex(
      b => Object.keys(b)[0] === Object.keys(row)[2]);
    let keyValueObject = structuredClone(assetMasterData[catEditIndex].Asset[assetIndex].Specifications[specIndex]);
    keyValueObject[Object.keys(keyValueObject)[0]] = Object.values(keyValueObject)[0].join(",")
    let tempEditdata = structuredClone(editData);
    tempEditdata.catIndex = catEditIndex;
    tempEditdata.assetIndex =assetIndex;
    tempEditdata.specIndex=specIndex;
    tempEditdata.keyValueObject = keyValueObject;
    setEditData(tempEditdata)
  }

  const onFormEditSubmit = async (e) =>{
    e.preventDefault();
    const id = assetMasterData[editData.catIndex]._id;
    // [Object.keys(editData.keyValueObject)[0]]
    const arrayedValues = (editData.keyValueObject[Object.keys(editData.keyValueObject)[0]]).trim().split(",").map(val => val.trim());
    const editedObject = {[Object.keys(editData.keyValueObject)[0]]:arrayedValues}
    const orgBody = JSON.parse(JSON.stringify(assetMasterData[editData.catIndex].Asset[editData.assetIndex]));
    orgBody.Specifications[editData.specIndex] = editedObject;
    const body = {...orgBody,"Index":editData.assetIndex, "id":id};
    const res = await editAssetOfCat(body);
    alert(`Specifications edited successfully`)
    setEditCategory(null)
  }

  const handleCancelClick = ()=>{
    setEditCategory(null);
  }

  const handleDeleteClick = async (e,k,row)=>{
    const catDeleteIndex = assetMasterData.findIndex(a=> a.Category === row.Category)
    const id = assetMasterData[catDeleteIndex]._id;
    const assetIndex = assetMasterData[catDeleteIndex].Asset.findIndex(a => a.Name === row.Name);
    if(assetIndex === -1){
      let body = {"id":id}
      if(window.confirm(`Are you sure you want to delete ${row.Name}`)){
        await deleteAssetMaster(body)
      }
      return;
    }
    const specIndex = assetMasterData[catDeleteIndex]?.Asset[assetIndex]?.Specifications?.findIndex(
      b => Object.keys(b)[0] === Object.keys(row)[2]);
    const orgBody = JSON.parse(JSON.stringify(assetMasterData[catDeleteIndex].Asset[assetIndex]));
    orgBody.Specifications.splice(specIndex,1);
    const body = {...orgBody,"Index":assetIndex, "id":id};
    if(window.confirm(`Are you sure you want to Delete`)){
      const res = await editAssetOfCat(body);
    }
    setSentData(body);
  }
  const handleSearchChange = (event, newValue, name) =>{
    let tempData = structuredClone(tarray(Object.values(assetmasters?.entities)));
    let tempSearchData = structuredClone(searchData);
    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
      setSearchData(tempSearchData);
     }else{
      tempSearchData[name] = newValue
      setSearchData(tempSearchData);
     }
     for(let key in tempSearchData){
      if(["Category", "Name"].includes(key) && tempSearchData[key]?.length){
        tempData = tempData.filter(x=> tempSearchData[key].map(item => item?.toLowerCase()).includes(x[key]?.toLowerCase()))
      }
      if(key === "Asset" && tempSearchData[key].length){
        tempData = tempData.filter(x=> tempSearchData[key].map(item => item?.toLowerCase()).includes(x[key]?.toLowerCase()))
      }
      if(key === "Specifications" && tempSearchData[key].length){
        tempData = tempData.filter(x =>  tempSearchData[key].includes(Object.keys(x)[2])) 
      }
      if(key === "values" && tempSearchData[key].length){
        tempData = tempData.filter(x => hasCommonElement(tempSearchData[key], x[Object.keys(x)[2]])) 
      }
    }
    setRows(tempData);
  }

//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["Category","Asset", "Specification", "Values"]
  let tempDownloadData = structuredClone(rows);
  for(let val of tempDownloadData ){
      let tempDoc = {};
      tempDoc = {...tempDoc, "Category": val.Category, "Asset":val.Name, "Specification":Object.keys(val)[2] ,"Values" :Object.values(val)[2]?.join(",") }
      finalDownloadData.push(tempDoc)
    }

    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [rows])

useEffect(()=>{
  setRows(tarray(assetMasterData))
},[assetMasterData])

  return (
    <>
      <BackArrowContainer onClick={onClickBackArrow}><ArrowLeftIcon /><span >Back to Category Table</span></BackArrowContainer>
      
      <HeadingWrap>
        <Span>Add New Asset/Spec/Values</Span>
      </HeadingWrap>
      
      <form style={{marginBottom:'20px', marginTop:'20px'}}>
        <TextField
          id="outlined-basic"
          size='small'
          label="Category"
          value={categProp}
          variant="outlined"
          readOnly
          sx={{backgroundColor:"white", width:"200px", height:"40px"}}
        />      
      </form>

      <form onSubmit={onFormSubmit} >
        <TextField
          id="outlined-basic"
          size='small'
          name='AssetName'
          onChange={(event) => onChangeAssetData(event)}
          label="Asset Name"
          value={onChangeData.AssetName? onChangeData.AssetName:""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"200px", height:"40px", marginBottom:"20px"}}
        />

        {[...Array(addSpecIndex)].map((e, i) =>
          <SpecInputContainer key={i}>
            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                name={`spec${i}`}
                onChange={(event, newValue) => onChangeAssetData(event, newValue)}
                label="Specification"
                value={onChangeData[`spec${i}`]? onChangeData[`spec${i}`]:""}
                variant="outlined"
                sx={{ backgroundColor:"white" }}
              />      
            </LabelInputWrapper>

            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                name={`value${i}`}
                onChange={(event, newValue) => onChangeAssetData(event, newValue)}
                label="Value"
                value={onChangeData[`value${i}`]? onChangeData[`value${i}`]:[]}
                variant="outlined"
                sx={{ backgroundColor:"white" }}
              />      
            </LabelInputWrapper>           
              {i === (addSpecIndex -1) &&  <IconWrapper><SubWrapper><AddIcon onClick={onClickaddicon} sx={{ fontSize: 30, marginBottom:"10px" }} />
              <RemoveIcon onClick={onClickremoveicon} sx={{ fontSize: 30, marginBottom:"10px" }} /><SubmitButton type='submit' >Submit</SubmitButton>
              </SubWrapper>
              <Button2Div>
                <ExcelDownload data={downloadData} filename={"assetMasterData"} sheetName={"sheet1"}/>
              </Button2Div> 
              </IconWrapper>}
            </SpecInputContainer>
            )}
      
      </form>
    <form onSubmit={onFormEditSubmit}  >  
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"7%"}}} align="center">Sl.No.</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Category</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Asset</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Specification</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Values</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Edit</TableCell>
         </TableRow>
         
         <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
         <TableCell></TableCell>
         <TableCell>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "Category")}
                size="small"
                value={searchData?.Category}
                options={assetmasters? Object.values(assetmasters?.entities).map(x => x.Category):[]}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Category"  sx={{background:"white", width:"90%"}} />
                )}
                /> 
          </TableCell>
          <TableCell>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "Name")}
                size="small"
                value={searchData?.Asset}
                options={assetmasters? Object.values(assetmasters?.entities).map(x => x.Asset.map(y=>y.Name)).flat(3).sort():[]}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Asset"  sx={{background:"white", width:"90%"}} />
                )}
                /> 
          </TableCell>
          <TableCell>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "Specifications")}
                size="small"
                value={searchData?.Specifications}
                options={assetmasters? Object.values(assetmasters?.entities).map(x => x.Asset.map(y=>y.Specifications.map(z=>Object.keys(z)))).flat(5).sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'})):[]}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Specs"  sx={{background:"white", width:"90%"}} />
                )}
                /> 
          </TableCell>
          <TableCell>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "values")}
                size="small"
                value={searchData.values}
                options={assetmasters? Object.values(assetmasters?.entities).map(x => x.Asset.map(y=>y.Specifications.map(z=>Object.values(z)))).flat(5).sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'})):[]}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Values"  sx={{background:"white", width:"90%"}} />
                )}
                /> 
          </TableCell>
          <TableCell></TableCell>

         </TableRow>
        </TableHead>

        <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row,k) => (
            <Fragment key = {k}>
              {editCategory === k+1?
              <SCMeditablerow k={k} row={row} page={page} rowsPerPage={rowsPerPage} SubmitButton = {SubmitButton}
               handleCancelClick={handleCancelClick} onFormEditSubmit={onFormEditSubmit} tableFontSize={tableFontSize}
               assetMasterData={assetMasterData} editData={editData} onChangeAssetData={onChangeAssetData} />:
              <SCMreadonlyrow k={k} row={row} page={page} rowsPerPage={rowsPerPage} onClickEdit={onClickEdit}
              handleDeleteClick={handleDeleteClick} tableFontSize ={tableFontSize} SubmitButton = {SubmitButton} />
              }
            </Fragment>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>      
    </TableContainer>
    </form> 
    </>  
  );
}
export default SubCategMaster;